import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem, StyledTable } from "./Components";
import ppe_haz_lev from "../img/sswpIcons/PPE/ppe_haz_lev.png"; //
import ppe_dus_mas from "../img/sswpIcons/PPE/ppe_dus_mas.png"; //
import ppe_ear_pro from "../img/sswpIcons/PPE/ppe_ear_pro.png"; //
import ppe_eye_pro from "../img/sswpIcons/PPE/ppe_eye_pro.png"; //
import ppe_fac_pro from "../img/sswpIcons/PPE/ppe_fac_pro.png"; //
import ppe_per_flo_ves from "../img/sswpIcons/PPE/ppe_per_flo_dev.png"; //
import ppe_rad_com_ala from "../img/sswpIcons/PPE/ppe_rad_con_ala.png"; //
import ppe_res_equ from "../img/sswpIcons/PPE/ppe_res_equ.png"; //
import ppe_kne_pad from "../img/sswpIcons/PPE/ppe_kne_pad.png"; //
import ppe_saf_boo_hiv from "../img/sswpIcons/PPE/ppe_saf_boo.png"; //
import ppe_saf_glo from "../img/sswpIcons/PPE/ppe_saf_glo.png"; //
import ppe_saf_har from "../img/sswpIcons/PPE/ppe_saf_har.png"; //
import ppe_saf_hel from "../img/sswpIcons/PPE/ppe_saf_hel.png"; //
import ppe_saf_ove from "../img/sswpIcons/PPE/ppe_saf_ove.png"; //
import ppe_hi_vis from "../img/sswpIcons/PPE/ppe_hi_vis.png"; //

const json = {
    icon: ppe_haz_lev,
    name: "PPE",
    text: (
        <ul>
            <ListItem text="PPE should never be used as a control measure by itself. First risk management controls need to be used, such as technical measures or work organisation methods. You should have a method statement that outlines the chosen method, and have adequate training and knowledge on what is to be done." />
            <ListItem text="PPE is the last line of defense to protect you from physical harm" />
            <ListItem text="The PPE required for your task should be specifically identified in the relevant sections of this form." />
        </ul>
    ),

    icons: {
        ppe_hi_vis: {
            name: "Hi-Visibility PPE",
            icon: ppe_hi_vis,
            text: (
                <ul>
                    <ListItem text="High visibility clothing (minimum Class 2) must be worn when working on roads or in the vicinity of plant. The minimum is Class 3 when working on motorways." />
                    <ListItem text="Class 3 High Visibility Clothing must be worn be Stop/Go Disc Operators" />
                    <ListItem text="The clothing must be worn fastened up." />
                    <ListItem text="The clothing must be in good condition (and within any garment maintenance conditions set out in the manufacturer’s label)" />
                    <ListItem text=" The clothing must be worn in accordance with any weather conditions set out in the manufacturer’s label." />
                </ul>
            )
        },

        ppe_saf_boo: {
            name: "Safety Boots",
            icon: ppe_saf_boo_hiv,
            text: (
                <ul>
                    <ListItem text="Safety boots/wellies should have steel toecaps and sole protection. For construction the relevant category is safety, i.e. EN ISO 20345 (not Protective or Occupational)." />
                    <Li>
                        <Typography variant="title">
                            Markings and suitability
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <td>SB</td>
                                    <td>Protective toecap only</td>
                                    <td>
                                        Only where there is no risk to damage
                                        underfoot
                                    </td>
                                </tr>
                                <tr>
                                    <td>S1</td>
                                    <td>
                                        SB+ Closed heel, energy absorption,
                                        antistatic, resistance to fuel oil
                                    </td>
                                    <td>
                                        Suitable for indoor, and not exposed to
                                        penetration risk
                                    </td>
                                </tr>
                                <tr>
                                    <td>S1P</td>
                                    <td>S1+ Penetration resistance</td>
                                    <td>
                                        Suitable for indoor, and not exposed to
                                        rainwater or outdoor elements
                                    </td>
                                </tr>
                                <tr>
                                    <td>S2</td>
                                    <td>S1P+ Water penetration</td>
                                    <td>
                                        Suitable for indoor, and not exposed to
                                        rainwater or outdoor elements
                                    </td>
                                </tr>
                                <tr>
                                    <td>S3</td>
                                    <td>
                                        S2+ Penetration resistance, cleated
                                        outside
                                    </td>
                                    <td>
                                        Most common, wide range of suitability
                                    </td>
                                </tr>
                                <tr>
                                    <td>S4</td>
                                    <td>
                                        S1+ Polymer/rubber moulded making them
                                        water and leak proof
                                    </td>
                                    <td>
                                        Where there is a constant presence of
                                        water/liquids and no penetration risk
                                    </td>
                                </tr>
                                <tr>
                                    <td>S5</td>
                                    <td>S4+ Midsole penetration resistance</td>
                                    <td>
                                        Where there is a constant presence of
                                        water/liquids.
                                    </td>
                                </tr>
                                <tr>
                                    <td>SRA</td>
                                    <td>Ceramic tile slip resistance</td>
                                    <td>Where there is low chance of slip</td>
                                </tr>
                                <tr>
                                    <td>SRB</td>
                                    <td>Smooth steel slip resistance</td>
                                    <td>Where increased chance of slip</td>
                                </tr>
                                <tr>
                                    <td>SRC</td>
                                    <td>Both SRA and SRB</td>
                                    <td>High chance of slip</td>
                                </tr>
                                <tr>
                                    <td>AN</td>
                                    <td>Ankle protection</td>
                                    <td>
                                        Uneven ground, or where operatives are
                                        required to mount outdoor plant/equipment
                                    </td>
                                </tr>
                                <tr>
                                    <td>WR</td>
                                    <td>Water repellant</td>
                                    <td>
                                        This can be worn in outdoor environments
                                        with more sustained wet weather (than
                                        basic S3)
                                    </td>
                                </tr>
                                <tr>
                                    <td>Cl</td>
                                    <td>Cold weather rating</td>
                                    <td>Standard level is -17oC</td>
                                </tr>
                                <tr>
                                    <td>Hl</td>
                                    <td>Heat resistance</td>
                                    <td>
                                        Minimum level is 150oC. Suitable for
                                        freshly laid tarmac.
                                    </td>
                                </tr>
                                <tr>
                                    <td>HRO</td>
                                    <td>Heat resistance</td>
                                    <td>
                                        Minimum level is 300oC. Suitable for
                                        freshly laid tarmac.
                                    </td>
                                </tr>
                                <tr>
                                    <td>M</td>
                                    <td>Metatarsal Protection</td>
                                    <td>
                                        Where operatives have to carry heavy
                                        objects
                                    </td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        ppe_saf_hel: {
            name: "Safety Helmet",
            icon: ppe_saf_hel,
            text: (
                <ul>
                    <ListItem text="Must be CE marked (EN 397 for Safety Helmets, EN 812 for bump caps)" />
                    <Li>
                        <Typography variant="title">
                            Must have the following markings
                        </Typography>
                        <ol>
                            <ListItem text="Size or range (both shell and harness)" />
                            <ListItem text="Year and quarter of manufacture" />
                            <ListItem text="Information label" />
                            <ListItem text="Shell material" />
                        </ol>
                    </Li>
                    <ListItem text="You should clean your safety helmet with soap and water and dry with soft  cloth. Do NOT use abrasive substances or solvents." />
                    <ListItem text="Do NOT store in direct sunlight or in contact with chemicals." />
                    <ListItem text="You should visually check your helmet before wearing. Any helmet showing more than superficial abrasions should be replaced." />
                    <ListItem text="In general helmets should be replaced after 5 years of general usage." />
                </ul>
            )
        },
        ppe_eye_pro: {
            name: "Eye Protection",
            icon: ppe_eye_pro,
            text: (
                <ul>
                    <ListItem text="Must meet the requirements of EN 166, and be correctly rated for the task" />
                    <ListItem text="S = Increased robustness" />
                    <ListItem text="F = Low energy impact" />
                    <ListItem text="B = Medium energy impact" />
                    <ListItem text="A = High energy impact (must be face shield)" />
                    <ListItem text="9 = Non-adherence of molten metal and resistance to penetration by hot solids" />
                    <ListItem text="K = Resistance to damage by fire particles" />
                    <ListItem text="N = Non-fogging properties" />
                </ul>
            )
        },
        ppe_fac_pro: {
            name: "Face Protection",
            icon: ppe_fac_pro,
            text: (
                <ul>
                    <ListItem text="Face protection must be provided where there is a risk of high energy impact, sparks or splashes from hot or harmful substances." />
                </ul>
            )
        },

        ppe_ear_pro: {
            name: "Ear Protection",
            icon: ppe_ear_pro,
            text: (
                <ul>
                    <ListItem text="Hearing protection must be worn above 80 dBA (as a guide, if it is difficult to hear normal conversation at 2m). You must also have audiometric screening available to you." />
                    <ListItem text="Above 85 dBA (as a guide, passing diesel truck) a programme to reduce noise exposure must be implemented. Warning signs must be displayed. You must have audiometric screening available to you." />
                    <Li>
                        <Typography variant="title">
                            Noise is limited to
                        </Typography>
                        <ol>
                            <ListItem text="87 dBA over 8 hours (as a guide, food blender), or" />
                            <ListItem text="140 dBA at Peak (as a guide, jet engine take off)" />
                        </ol>
                    </Li>
                    <ListItem text="Hearing protection must be to IS EN 352" />
                </ul>
            )
        },
        ppe_saf_glo: {
            name: "Safety Gloves",
            icon: ppe_saf_glo,
            text: (
                <ul>
                    <ListItem text="The glove should fit the wearer and be within any expiry date." />
                    <Li>
                        <Typography variant="title">
                            They must carry a CE mark (EN 420 norm), and equipped with
                        </Typography>
                        <ol>
                            <ListItem text="Name, address of manufacturer" />
                            <ListItem text="Glove symbol or code" />
                            <ListItem text="Size and size chart" />
                            <ListItem text="Expiry date (if applicable)" />
                            <ListItem text="Graphic sign, indicating risk category" />
                            <ListItem text="Standard reference" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Grouping Category
                        </Typography>
                        <ol>
                            <ListItem text="Minor risk: not suitable for construction activities, protects from mild damage, temperatures and chemical exposure" />
                            <ListItem text="Mainly gloves protecting from construction or mechanical harm" />
                            <ListItem text="Protection from irreversible damage and lethal dangers" />
                        </ol>
                    </Li>
                    <ListItem text="For general construction should offer protection from liquids, have good finger flexibility, protection from chemicals while handling objects, good grip, high level of mechanical properties, long-lasting and shield from cuts." />
                    <ListItem text="Also consider need (and associated glove markings) for waterproofing, complex handling of objects in the presence of oily substances, comfort, thermal protection, sustainability for heavy works, protection while handling heavy and sharp objects, chemical resistance (for chemical being handled), dexterity." />
                </ul>
            )
        },
        ppe_dus_mas: {
            name: "Dust Mask",
            icon: ppe_dus_mas,
            text: (
                <ul>
                    <ListItem text="To be worn if there is a risk of harmful dust" />
                </ul>
            )
        },
        ppe_res_equ: {
            name: "Respiratory Equipment",
            icon: ppe_res_equ,
            text: (
                <ul>
                    <ListItem text="Respiratory equipment must not be used to replace other means of making the air safe." />
                    <ListItem text="It must be CE marked. It must be worn correctly and in accordance with the manufacturer’s instructions" />
                    <ListItem text="Respiratory equipment must be well maintained and the filter media must be clean. Cleaning is only permitted when identified by the manufacturer, and must be done in accordance with their instructions." />
                    <ListItem text="Before use check the equipment for wear and tear, that all components are within expiry dates, and that all valves/seals are fully intact and operating." />
                    <ListItem text="The equipment should be fit tested for the wearer to ensure a tight seal. This may need to be repeated by the wearer, if they lose or gain weight, or if they develop any facial changes (scars, moles etc)" />
                    <ListItem text="The equipment must be stored in a hygenic and uncontaminated area (pay particular attention for contaminated work clothing)." />
                    <ListItem text="Air purifying respiratory equipment should not be used in confined space as protection against high concentration of gases, or oxygen deficient atmospheres. This will require respiratory protective equipment." />
                    <Li>
                        <Typography variant="title">
                            The type of filter should be selected as follows
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Substance</th>
                                    <th>Filter Type</th>
                                    <th>Color</th>
                                </tr>
                                <tr>
                                    <td>Particles</td>
                                    <td>P</td>
                                    <td>White</td>
                                </tr>
                                <tr>
                                    <td>
                                        Organic gases and vapours (Boiling point
                                        >65oC)
                                    </td>
                                    <td>A</td>
                                    <td>Brown</td>
                                </tr>
                                <tr>
                                    <td>Inorganic gases and varpors</td>
                                    <td>B</td>
                                    <td>Grey</td>
                                </tr>
                                <tr>
                                    <td>Suplhur dioxide and acidic gases</td>
                                    <td>E</td>
                                    <td>Yellow</td>
                                </tr>
                                <tr>
                                    <td>Ammonia</td>
                                    <td>K</td>
                                    <td>Green</td>
                                </tr>
                                <tr>
                                    <td>Mercury</td>
                                    <td>Hg (P3 filter) (single use)</td>
                                    <td>Red-White</td>
                                </tr>
                                <tr>
                                    <td>Oxides of nitrogen</td>
                                    <td>NO (P3 filter) (single use)</td>
                                    <td>Blue-White</td>
                                </tr>
                                <tr>
                                    <td>
                                        Organic gases and vapours (Boiling point
                                        65oC+)
                                    </td>
                                    <td>AX (Single use)</td>
                                    <td>Brown</td>
                                </tr>
                                <tr>
                                    <td>Specific Substance Filter</td>
                                    <td>SX & Chemical name</td>
                                    <td>Violet or Violet-White</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Particle Filters have three classes
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <td>P1</td>
                                    <td>Low Efficiency</td>
                                    <td>Assigned Protection Factor 4</td>
                                </tr>
                                <tr>
                                    <td>P2</td>
                                    <td>Medium Efficiency</td>
                                    <td>Assigned Protection Factor 10</td>
                                </tr>
                                <tr>
                                    <td>P3</td>
                                    <td>High Efficiency</td>
                                    <td>Assigned Protection Factor 20</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        ppe_saf_ove: {
            name: "Safety Overalls",
            icon: ppe_saf_ove,
            text: (
                <ul>
                    <ListItem text="Should be snug fitting and kept clean." />
                    <ListItem text="Basic Protective Coveralls offers long-wearing protection, not just against dirt and grime, and some spark protection" />
                    <ListItem text="Disposable Coveralls are suitable for you require a protective barrier against particulates, aerosols and non-hazardous liquids. They are also suitable for works that will ruin clothing quickly such as dirt, grime, paint or other substances." />
                    <ListItem text="Fire retardant coveralls are inherently fire resistant" />
                    <ListItem text="Quilted coveralls will provide some thermal insulations" />
                    <ListItem text="Arc-resistance coveralls will offer some protection from electric shock" />
                    <ListItem text="Water-proof coveralls will protect from rain for outdoor workers." />
                    <ListItem text="Coveralls used when working on the public road should have high visibility." />
                </ul>
            )
        },
        ppe_kne_pad: {
            name: "Knee Pads",
            icon: ppe_kne_pad,
            text: (
                <ul>
                    <ListItem text="Workers who have to kneel frequently or constantly while working should use knee pads." />
                </ul>
            )
        },
        ppe_saf_har: {
            name: "Safety Harness",
            icon: ppe_saf_har,
            text: (
                <ul>
                    <ListItem text="Cannot be used to replace safe working platforms or safety nets. (Fall restraint)." />
                    <ListItem text="Fall Arrest and Rescue equipment needs to be inspected regularly and visually before each use." />
                    <ListItem text="Operatives must be trained" />
                    <Li>
                        <Typography variant="title">
                            Should be used in connection with a rescue plan.
                            This plan must ensure the operative can be retrieved
                            as soon as possible after the fall and NOT wait on
                            emergency services response. There are 4 classes of
                            rescue, risk assessed for most suitable
                        </Typography>
                        <ol>
                            <ListItem text="Lowering a remote casualty" />
                            <ListItem text="Raising a remote casualty" />
                            <ListItem text="Self evacuation by descent" />
                            <ListItem text="Rescue another in descent (preferably avoided so that other complications are not introduced)" />
                        </ol>
                        <Typography variant="title">
                            The rescuer should not endanger themselves when
                            carrying out a rescue procedure
                        </Typography>
                    </Li>
                    <ListItem text="Will consist of a full-body harness (with webbing and padding), lanyard, shock absorber (if fall arrest rather than fall restraint) and suitable anchor/ tie off point." />
                    <ListItem text="The anchor must be capable of supporting the load in the required direction." />
                    <ListItem text="Ensure proper tie off to anchor points, and re-check before commencing, irrespective of how short the task is going to be." />
                    <ListItem text="The harness must be worn fully secured, comfortable but snug and positioned correctly." />
                    <ListItem text="All connection systems must have double action, self closing, self locking snap hooks to reduce the possibility of roll out" />
                    <ListItem text="Use safety helmets (With chin straps) instead of hard hats.Where the risk of drowning is greater than the risk of falling, a personal flotation device should be used instead of a harness. Other fall controls (instead of a harness) should still be used." />
                </ul>
            )
        },
        ppe_per_flo_dev: {
            name: "Floatation Device/ Life Jacket",
            icon: ppe_per_flo_ves,
            text: (
                <ul>
                    <ListItem text="Where the risk of drowning is greater than the risk of falling, a personal flotation device should be used instead of a harness. Other fall controls (instead of a harness) should still be used." />
                    <ListItem text="The flotation device must be stored and maintained in accordance with the manufacturer’s instructions" />
                    <ListItem text="The device must be checked by the wearer before each use, for signs of wear/ damage." />
                    <ListItem text="The device must be thoroughly examined every 12 months by a competent person and certified. The certificate must be available to the wearer." />
                </ul>
            )
        },
        ppe_rad_con_ala: {
            name: "Radios/ Communication/ Personal Alarms",
            icon: ppe_rad_com_ala,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            2-way radios provide a reliable means of
                            communication
                        </Typography>
                        <ol>
                            <ListItem text="Only one operator can talk at a time" />
                            <ListItem text="Hold down the talk button, talk while button held, when finished release the talk button" />
                            <Li>
                                <Typography variant="title">
                                    You should be clear and concise with your
                                    communication
                                </Typography>
                                <ul>
                                    <ListItem text="Identify who is talking" />
                                    <ListItem text="Give information" />
                                    <ListItem text="End communication with “over”" />
                                </ul>
                            </Li>
                        </ol>
                    </Li>
                    <ListItem text="Radios should be tested 2 times per day for battery and agreed channel" />
                    <ListItem text="The supervisor should have handset themselves" />
                    <ListItem text="Mobile phones should not be used to replace radios" />
                    <ListItem text="An agreed responding person is required when using personal alarms. The personal alarm system should be periodically tested. The test should review the responding system and ensure an adequate response time is achieved." />
                    <ListItem text="For low risk lone working, phones may be used as part of a check-in/check-out personal alarm system. If a communication is not received by the responding person at the agreed time, then a response action should be initiated." />
                </ul>
            )
        }
    }
};
export default json;
